import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

  //custom comps
import GDriveTest from './GDriveTest';
import BarcodeScanner from './BarcodeScanner';
import Home from './Home';
import Products from './Products';
import DLStockr from './dlstockr';
import About from './About';
import Learn from './Learn';
import Support from './Support';
import Contact from './Contact';


  const styles = theme => ({
    root: {
      flexGrow: 1,
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      padding: theme.spacing.unit,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  });


export default class NavC extends Component {
    state = {
        value: 0,
      };
    
      handleChange = (event, value) => {
        this.setState({ value });
      };
render() {
    
    
    const { classes } = this.props;
    const { value } = this.state;
return (
    <div className="App">
        <div>
        <div>
        <Router>
        <Navbar color="light" light expand="md">
          <NavbarBrand href="/" style={{color: '#1E90FF'}}>DesignLove Consultancy</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                   <strong> Menu</strong>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    <Link to="/products">Products and Services</Link>
                  </DropdownItem>
                  <DropdownItem>
                      <Link to="/about">About</Link>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem>
                      <Link to="/learn">Learn</Link>
                  </DropdownItem>
                  <DropdownItem>
                      <Link to="/support">Support</Link>
                  </DropdownItem>
                  <DropdownItem>
                      <Link to="/contact">Contact</Link>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>



        <Route path="/" exact component={Home} />
        <Route path="/products" exact component={Products} />
        <Route path="/dlstockr" component={DLStockr} />
        <Route path="/about" component={About} />
        <Route path="/learn" component={Learn} />
        <Route path="/support" component={Support} />
        <Route path="/contact" component={Contact} />
            </Router>
        </div>
        </div>
    </div>
    
      )
    }
}


// WEBPACK FOOTER //
// ./src/components/Nav.js